import { FC } from "react";
import Highlighter from "react-highlight-words";

interface IAiConversationDetailsRawProps {
  rawReasoning: string;
  searchTerm?: string;
}

export const AiConversationDetailsRaw: FC<IAiConversationDetailsRawProps> = ({
  rawReasoning,
  searchTerm,
}) => {
  if (!rawReasoning?.trim()) {
    return <span>—</span>;
  }

  return (
    <pre className="raw-text-pre">
      {searchTerm ? (
        <Highlighter
          searchWords={[searchTerm]}
          autoEscape={true}
          textToHighlight={rawReasoning}
          highlightClassName="search-highlight"
        />
      ) : (
        rawReasoning
      )}
    </pre>
  );
};
